export const SET_GDPR_ERASURE_LOG_LOADING = "SET_GDPR_ERASURE_LOG_LOADING";
export const SET_GDPR_ERASURE_LOG_PAGE_DATA = "SET_GDPR_ERASURE_LOG_PAGE_DATA";
export const SET_GDPR_ERASURE_LOG_FILTERS = "SET_GDPR_ERASURE_LOG_FILTERS";
export const SET_GDPR_ERASURE_LOG_PAGE = "SET_GDPR_ERASURE_LOG_PAGE";
export const SET_GDPR_ERASURE_LOG_SIZE = "SET_GDPR_ERASURE_LOG_SIZE";
